module.exports = __webpack_public_path__ + "static/media/blogger-social-media-svgrepo-com (1).8428dd61.svg";